module.exports = __webpack_public_path__ + "img/IMG_5900.4a00573f.jpg";